import { useState } from 'react';
import type { TitleGroup } from '@/services/title-group';

export default () => {
  const [showForm, setShowForm] = useState(false);
  const [pickedData, setPickedData] = useState<TitleGroup | null>(null);
  const [loading, setLoading] = useState(false);

  const closeForm = () => {
    setShowForm(false);
    setPickedData(null);
  };

  const openCreateForm = () => {
    setPickedData(null);
    setShowForm(true);
  };

  const openEditForm = (data: TitleGroup) => {
    setPickedData(data);
    setShowForm(true);
  };

  return {
    // State
    showForm,
    pickedData,
    loading,
    // Actions
    setShowForm,
    setPickedData,
    setLoading,
    closeForm,
    openCreateForm,
    openEditForm,
  };
};
